import { ReactNode } from 'react'
import { css, Theme } from '@emotion/react'

const sectionTitleStyle = css`
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 18px;
  color: #454545;
  margin-bottom: 16px;
`

export type Props = {
  number: number
  title: string
  children: ReactNode
  isFirst?: boolean
}

export default function DetailSection({
  number,
  title,
  children,
  isFirst = false,
}: Props) {
  const style = (t: Theme) => css`
    margin-top: ${isFirst ? '0' : '16px'};
    padding-top: ${isFirst ? '0' : '16px'};
    border-top: ${isFirst ? 'none' : `1px solid ${t.c.ec.mediumGray}`};
  `

  return (
    <div css={style}>
      <h3 css={sectionTitleStyle}>
        {number} {title}
      </h3>
      {children}
    </div>
  )
}
